import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class TimeValidator {
    static timeFormat(allowThreeDigitHours: boolean = false): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            // Allow empty value or time format HH:MM or HHH:MM
            const timeRegex = allowThreeDigitHours ? /^([0-9]{1,3}):([0-9]{2})$/ : /^([0-9]{1,2}):([0-9]{2})$/;
            if (!timeRegex.test(control.value)) {
                return { timeFormat: true };
            }

            const [, minutes] = control.value.split(':').map(Number);
            if (minutes >= 60) {
                return { invalidMinutes: true };
            }

            return null;
        };
    }

    static maxTime(maxHours: number, maxMinutes: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            const [hours, minutes] = control.value.split(':').map(Number);
            const totalMinutes = hours * 60 + minutes;
            const maxTotalMinutes = maxHours * 60 + maxMinutes;

            if (totalMinutes > maxTotalMinutes) {
                return { maxTimeExceeded: true };
            }

            return null;
        };
    }
}
